import { createRoute } from '@tanstack/react-router'
import { rootRoute } from './root'
import { AuthPage } from '../features/auth/page'

export const authRoute = createRoute({
  path: 'auth',
  getParentRoute: () => rootRoute,
  component: AuthPage,
})
